import { EApplicationType } from 'shared/types/applicationType';
import { createApplicationState } from 'browser/services/applicationState';
import { renderApplication } from 'browser/services/renderApplication';
import { renderPromoApplication } from 'browser/services/renderPromoApplication';

import { createContext } from './createContext';

export function runApp(): void {
  const context = createContext();

  if (
    context.custom.applicationType === EApplicationType.ProjectsList ||
    context.custom.applicationType === EApplicationType.ProjectEditor
  ) {
    const store = createApplicationState(context);
    renderApplication({ context, store });
  } else {
    renderPromoApplication({ context });
  }
}
